import { helper } from '@ember/component/helper';

import { neq } from 'rise-ui/utils/choice.js';

export default helper(function neqHelper(params) {
  return neq(...params);
});
